import { siteTexts } from "../../../shared/i18n/siteTexts";
import type { PairMode } from "../../challenges/types/challengeDraft";

type AdminParticipantNoticeInput = {
  competitionLocked: boolean;
  currentPairMode: PairMode;
  draftPairsCount: number;
  draftPlayersCount: number;
  isSuper8: boolean;
  maxDrawPlayers: number | null;
  maxFixedPairs: number | null;
  registrationsOpen: boolean;
  super8MainPlayersCount: number;
  super8WaitingPlayersCount: number;
};

export function resolveAdminParticipantNotice({
  competitionLocked,
  currentPairMode,
  draftPairsCount,
  draftPlayersCount,
  isSuper8,
  maxDrawPlayers,
  maxFixedPairs,
  registrationsOpen,
  super8MainPlayersCount,
  super8WaitingPlayersCount,
}: AdminParticipantNoticeInput) {
  if (competitionLocked) {
    return siteTexts.challengeEngine.labels.competitionAlreadyStarted;
  }

  if (
    currentPairMode === "draw" &&
    maxDrawPlayers !== null &&
    draftPlayersCount >= maxDrawPlayers
  ) {
    return `Limite de ${maxDrawPlayers} jogadores atingido.`;
  }

  if (
    currentPairMode === "fixed" &&
    maxFixedPairs !== null &&
    draftPairsCount >= maxFixedPairs
  ) {
    return `Limite de ${maxFixedPairs} duplas atingido.`;
  }

  if (!registrationsOpen) {
    return siteTexts.challengeEngine.labels.openRegistrationsBeforeParticipants;
  }

  if (!isSuper8) return null;

  return `O Super 8 é disputado por exatamente 8 participantes. Ordem automática por ranking oficial: ${super8MainPlayersCount}/8${
    super8WaitingPlayersCount > 0
      ? ` • Reserva (${super8WaitingPlayersCount})`
      : ""
  }`;
}
